import { WhitelabelConfig } from "@/whitelabel/helpers/types";
import { channel } from "@/lib/Types/Channel";
import { AllURLParams } from "@/lib/Types/URLParameters";

export type ViewModeConfig = {
  channel: channel;
  cview: string;
  name: string;
  path: string;
  trackingName: string;
  mandator: number;
  profile: number;
};

const viewModeConfigUrlaub: Omit<ViewModeConfig, "mandator" | "profile"> = {
  channel: channel.PACKAGE,
  cview: "urlaub",
  name: "Urlaub",
  path: "urlaub",
  trackingName: "Pauschal",
};

const viewModeConfigHotel: Omit<ViewModeConfig, "mandator" | "profile"> = {
  channel: channel.HOTEL,
  cview: "hotel",
  name: "Hotel",
  path: "hotels",
  trackingName: "Hotel",
};

const viewModeConfigHlp: Omit<
  ViewModeConfig,
  "mandator" | "profile" | "cview" | "trackingName"
> = {
  name: "hlp",
  channel: channel.PACKAGE,
  path: "",
};

export const getViewModeConfig = (
  key: string,
  viewMode: WhitelabelConfig["viewMode"]
): ViewModeConfig => {
  switch (key) {
    case "hotels":
      return {
        ...viewModeConfigHotel,
        mandator: viewMode.mandator,
        profile: viewMode.profile.hotel ?? viewMode.profile.package,
      };
    case "hlp":
      return {
        ...viewModeConfigHlp,
        mandator: viewMode.mandator,
        profile: viewMode.profile.package,
        cview: "", // Add a default value for cview
        trackingName: "", // Add a default value for trackingName
      };
    case "urlaub":
    default:
      return {
        ...viewModeConfigUrlaub,
        mandator: viewMode.mandator,
        profile: viewMode.profile.package,
      };
  }
};

export const viewModeFromPathAndQuery = (
  path = "",
  searchParams: AllURLParams,
  viewModeProp: WhitelabelConfig["viewMode"]
): ViewModeConfig => {
  const viewMode = viewModeProp;

  if (path.includes("urlaub") || searchParams?.cview === "urlaub") {
    return getViewModeConfig("urlaub", viewMode);
  }
  if (path.includes("hotels/") || searchParams?.cview === "hotel") {
    return getViewModeConfig("hotels", viewMode);
  }
  if (path.includes("hotel") && searchParams?.cview === undefined) {
    return getViewModeConfig("hlp", viewMode);
  }
  return getViewModeConfig("urlaub", viewMode);
};
